import api from "./api";

export const fetchOopDetails = async (memberId, asOfDate) => {
  try {
    const params = new URLSearchParams();
    if (asOfDate) {
      params.append("asOfDate", asOfDate);
    }
    const response = await api.get(
      `/outreach/members/${memberId}/oop?${params.toString()}`,
      {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("fetchOopDetails failed:", error?.message);
    return null;
  }
};
